import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Card } from '@core/models/card';
import { ICourses } from '@core/interfaces/ilookup';
import { IUserCourse } from '@views/features/courses/interfaces/iuser-course';
import { IImpactVideoResponse } from '@views/features/resources/interfaces/iimpact-video';
import { IResource } from '@views/features/resources/interfaces/iresource';

@Injectable({
  providedIn: 'root'
})
export class CardService {
  private router = inject(Router);

  mapCardDataToDataList<T extends ICourses | IResource | IUserCourse | IImpactVideoResponse>(dataType: string, dataList: T[], sasToken: string): Card[] {
    return dataList.map(data => {
      switch (dataType) {
        case 'courses':
          return this.getCardData(data as ICourses, sasToken);
        case 'resources':
          return this.getResourceCardData(data as IResource, sasToken);
        case 'user-course':
          return this.getUserCardData(data as IUserCourse, sasToken);
        case 'impact-videos':
          return this.getImpactCardData(data as IImpactVideoResponse, sasToken);
        default:
          throw new Error('Unknown data type');
      }
    }) || [];
  }

  getCardData(course: ICourses, sasToken: string): Card {
    return new Card({
      id: course.id,
      title: course.name,
      summary: course.summary,
      author: course.author,
      url: course.url,
      img: `assets/courses/Course ${course.id}.jpg`,
    });

  }

  getResourceCardData(resource: IResource, sasToken: string): Card {
    debugger;
    return new Card({
      id: resource.id,
      title: resource.title,
      description: resource.description,
      author: resource.createdByName,
      url: resource.imageLink,
      img: `assets/resources/${resource.title.trim()}.png`,
    });
  }

  getUserCardData(userCourse: IUserCourse, sasToken: string): Card {
    return new Card({
      id: userCourse.id,
      courseId: userCourse.courseId,
      userCourseId: userCourse.id,
      title: userCourse.course.name,
      summary: userCourse.course.summary,
      author: userCourse.course.author,
      url: userCourse.course.url,
      img: `assets/courses/Course ${userCourse.courseId}.jpg`,
      sasToken: sasToken,
      isCompleted: userCourse.isCompleted,
      status: userCourse.status
    });
  }

  getImpactCardData(video: IImpactVideoResponse, sasToken: string): Card {
    return new Card({
      id: video.id,
      title: video.title,
      author: video.createdByName,
      img: video.imageLink,
      url: video.videoLink,
      sasToken: sasToken,
      cardCss: {
        mainCard: 'relative flex flex-col border w-[346px] h-[500px] rounded-lg border-solid border-[#661985] overflow-hidden',
        image: 'absolute inset-0 w-full h-full object-cover object-center z-0', // Ensures image covers the entire card
        body: 'absolute bottom-0 left-0 w-full min-h-[200px] text-lg text-white impact-heading  z-[2] flex flex-col',
        title: 'text-[1.4rem] font-bold z-[2] truncate-2'
      }
    });
  }

  viewCard(courseId: number, url: string, userCourseId?: number): void {
    const path = userCourseId ? `${url}${courseId}/${userCourseId}` : `${url}${courseId}`;
    this.router.navigate([path]);
  }
}
